import { NotificacoesListSearchComponent } from './NotificacoesListSearchComponent'
import { NotificacoesListToolbar } from './NotificacoesListToolbar'

export const NotificacoesListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <NotificacoesListSearchComponent actions={<NotificacoesListToolbar />} />
    </div>
  )
}
